export default __webpack_public_path__ + "static/media/10.287c2b28.svg";